export default Object.freeze({
  Bookmark: 'Bookmark',
  ActionEngine: 'ActionEngine',
  CallAssist: 'CallAssist',

  // Front-end specific
  Placeholder: 'Placeholder',
});
